import React from 'react';
import { ArrowRight } from 'lucide-react';
import JourneyModal from './JourneyModal';
import JourneyList, { JourneyActions, JourneyFoot, OkBox } from './JourneyList';

/**
 * Two-step application submit pop-up.
 *  step "confirm"   – what happens next, then Submit application
 *  step "submitted" – confirmation; Done continues to the under-review screen
 */
const SubmitApplicationModal = ({ step, sectionCount, busy, onCancel, onSubmit, onDone, onRefer }) => {
    const submitted = step === 'submitted';

    return (
        <JourneyModal
            open={!!step}
            onClose={submitted ? onDone : onCancel}
            busy={busy}
            icon={submitted ? 'check' : 'submit'}
            title={submitted ? 'Application submitted' : 'Ready to submit your application?'}
            subtitle={submitted
                ? "We'll email you within 24–72 hours — either way"
                : 'A member of the Wripple talent team reads every one'}
        >
            {!submitted && <OkBox>All {sectionCount} sections complete</OkBox>}

            <JourneyList
                title="What happens next"
                rows={submitted ? [
                    { kind: 'stepnow', label: 'Wripple reviews your application', meta: '24–72 hours' },
                    { kind: 'step', label: 'Build your profile', meta: '~11 min', detail: 'If approved — your answers carry over.' },
                    { kind: 'step', label: 'Go live to clients' },
                ] : [
                    { kind: 'stepnow', label: 'Submit your application', meta: 'now' },
                    { kind: 'step', label: 'Wripple reviews it', meta: '24–72 hours' },
                    { kind: 'step', label: 'If approved, build your profile', meta: '~11 min' },
                ]}
            />

            <JourneyActions>
                {submitted ? (
                    <button type="button" className="btn btn-primary px-8" onClick={onDone}>Done</button>
                ) : (
                    <>
                        <button type="button" className="btn btn-outline-dark px-6" disabled={busy} onClick={onCancel}>
                            Keep editing
                        </button>
                        <button type="button" className="btn btn-primary inline-flex items-center justify-center gap-2 px-6" disabled={busy} onClick={onSubmit}>
                            {busy ? 'Submitting...' : <>Submit application <ArrowRight className="h-4 w-4" /></>}
                        </button>
                    </>
                )}
            </JourneyActions>

            {submitted && (
                <JourneyFoot>
                    Know someone who should be on Wripple?{' '}
                    <button type="button" onClick={onRefer} className="bg-transparent border-0 p-0 text-gray-600 underline">
                        Refer a colleague
                    </button>
                </JourneyFoot>
            )}
        </JourneyModal>
    );
};

export default SubmitApplicationModal;
